import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DestinationsImage from './DestinationsImages'

const copy = {
  overline: `Destinations`,
  heading: `Power all your tools with the same data`,
  description: `Enable the best product analytics, A/B testing, and data warehouse tools with first-party data.`,
}

export const Destinations = () => {
  return (
    <SectionComponent variant="2Col" copyVariant="narrow">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="h2">{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <DestinationsImage />
      </Section.Contents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow-x: visible;
  justify-content: center;
  ${Section.Wrapper} {
    padding-top: 40px;
    padding-bottom: 40px;
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

export default Destinations
